import {isNotNilOrEmpty} from 'ramda-adjunct';

import {AuditDataAssetsFilesBody} from '../../../types/AuditDataAssetsFilesBody';
import {getParsedValue} from './getParsedValue';

type CollectDamageAssetsInput = {
  damageId: string;
  /** Assets already stored for the source photo param. */
  assets: AuditDataAssetsFilesBody[];
  /** Assets staged (added) for that param during the current edit session. */
  stagedAssets: AuditDataAssetsFilesBody[];
  /** imageIds the user removed during the current edit session. */
  deletedImageIds: string[];
};

/**
 * Returns the assets that belong to `damageId` under one photo param — the stored assets plus the
 * session-staged ones, minus anything the user removed this session. Used to collect the photos
 * that must follow a damage when it is moved to another part.
 */
export const collectDamageAssets = ({
  damageId,
  assets,
  stagedAssets,
  deletedImageIds,
}: CollectDamageAssetsInput): AuditDataAssetsFilesBody[] =>
  [...assets, ...stagedAssets].filter((asset) => {
    const belongsToDamage = getParsedValue(asset.meta)?.damageId === damageId;
    const isDeleted =
      isNotNilOrEmpty(asset.imageId) && deletedImageIds.includes(asset.imageId ?? '');

    return belongsToDamage && !isDeleted;
  });
